<template>
  <div class="col" style="margin-top: 150px">
    <div class="row" style="display: flex; justify-content: space-around;">
      <b-card
        class="mv-card"
        header-class="text-center"
        title="Kontakt:"
        style="margin: 2px; width: 100%;">
        <template v-slot:header>
          <!-- <i class="mdi mdi-mail" style="font-size: 32px;"></i> -->
          <b-icon icon="mailbox" style="font-size: 32px;"></b-icon>
        </template>
        <p>
          Telefon: +49 176 22728476
        </p>
        <p>
          email: info@magivinum.de
        </p>
        <template v-slot:footer>
          <center>
            <b-button class="mx-2" href="https://www.facebook.com/MagiVinum/">
              <!-- <i class="mdi mdi-facebook" style="font-size: 16px;"></i> -->
              <b-icon icon="facebook" style="font-size: 32px;"></b-icon>
            </b-button>
            <b-button class="mx-2">
              <!-- <i class="mdi mdi-linkedin" style="font-size: 16px;"></i> -->
              <b-icon icon="linkedin" style="font-size: 32px;"></b-icon>
            </b-button>
            <b-button class="mx-2" href="https://www.instagram.com/magivinum/">
              <!-- <i class="mdi mdi-instagram" style="font-size: 16px;"></i> -->
              <b-icon icon="instagram" style="font-size: 32px;"></b-icon>
            </b-button>
          </center>
        </template>
      </b-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Contact',
  created () {
    /* eslint quote-props: ["error", "as-needed", { "unnecessary": false }] */
    this.$tracker('event', 'screen_view', {
      'app_name': 'magiv',
      'screen_name': 'Contact'
    })
  },
  components: {
    // HelloWorld
  }
}
</script>
<style scoped>
.cmpn-card-item {
  display: flex;
  flex: 1 0 auto;
  min-width: 200px;
  width: 45%;
}
</style>
